import type { ReactNode } from 'react';
import { useAuthStore } from '../stores/authStore';
import type { Role } from './roles';

interface RoleGuardProps {
  roles: Role[];
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Pillar 2 — Role-Aware React.
 * Hide/show subtrees by role. ALWAYS pair with server-side projection — this
 * component is a UX convenience only and is NOT a security boundary.
 */
export function RoleGuard({ roles, children, fallback = null }: RoleGuardProps) {
  const role = useAuthStore((s) => s.user?.role);
  if (!role || !roles.includes(role)) return <>{fallback}</>;
  return <>{children}</>;
}
